export const fmt  = (v) => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:2,maximumFractionDigits:2});
export const fmt4 = (v) => parseFloat(v||0).toLocaleString("pt-BR",{minimumFractionDigits:4,maximumFractionDigits:6});

export const STATUS_COR   = {PENDENTE:"var(--z-warning-text)",PAGO:"var(--z-success-text)",CANCELADO:"var(--z-text-muted)"};
export const STATUS_LABEL = {PENDENTE:"Pendente",PAGO:"Pago",CANCELADO:"Cancelado"};

// Fornecedores cujos itens NAO sao de producao (escritorio, etc)
export const FORNECEDORES_IGNORAR = ["ARMARINHOS FERNANDO LTDA"];

// Converte valor unitario considerando unidade
export const precoUnitReal = (valor, unidade) => {
  const v = parseFloat(valor||0);
  const u = (unidade||"").toLowerCase().trim();
  if(["mil","mih"].includes(u)) return v/1000;
  if(["cent","c"].includes(u)) return v/100;
  if(["dz","duz"].includes(u)) return v/12;
  return v;
};

export const fmtPrecoUnit = (valor, unidade) => {
  const real = precoUnitReal(valor, unidade);
  return `R$ ${real.toLocaleString("pt-BR",{minimumFractionDigits:4,maximumFractionDigits:6})}/un`;
};

export const CATS_NAO_PRODUCAO = ["PRODUTO_FINAL","MONTAGEM_VARAL","MONTAGEM_KIT","MONTAGEM_MV","SEMIACABADO"];
